module.exports = __webpack_public_path__ + "img/hunan.922fd5d7.png";